import { t } from 'i18next';
import * as Yup from 'yup';

import { LABELS } from '../../keys';

export enum PixDestinationType {
  PixKey = 'pixKey',
  BrCode = 'brCode',
}

export interface PixFormValues {
  destinationType: PixDestinationType;
  destinationValue: string;
  documentNumber: string;
  bankName: string;
  accountOwnerName: string;
}

export const normalizeDocumentDigits = (value: string): string => value.replace(/\D/g, '');

export const isValidCpfOrCnpj = (value: string): boolean => {
  const digits = normalizeDocumentDigits(value);
  return digits.length === 11 || digits.length === 14;
};

export const getPixDestinationOptions = () => [
  { key: PixDestinationType.PixKey, label: t(LABELS.CREATE_MODAL.PIX_DESTINATION_TYPE.PIX_KEY) },
  { key: PixDestinationType.BrCode, label: t(LABELS.CREATE_MODAL.PIX_DESTINATION_TYPE.BR_CODE) },
];

export const getPixInitialValues = (): PixFormValues => ({
  destinationType: PixDestinationType.PixKey,
  destinationValue: '',
  documentNumber: '',
  bankName: '',
  accountOwnerName: '',
});

export const getPixValidationSchema = () =>
  Yup.object({
    destinationType: Yup.mixed<PixDestinationType>().oneOf(Object.values(PixDestinationType)).required(),
    destinationValue: Yup.string().trim().required(t(LABELS.ERRORS.REQUIRED_FIELD)),
    documentNumber: Yup.string()
      .trim()
      .test('cpf-cnpj', t(LABELS.ERRORS.INVALID_CPF_CNPJ), (value) => !value || isValidCpfOrCnpj(value)),
    bankName: Yup.string().trim().required(t(LABELS.ERRORS.REQUIRED_FIELD)),
    accountOwnerName: Yup.string().trim().required(t(LABELS.ERRORS.REQUIRED_FIELD)),
  });
